import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { transformMenu } from '@angular/material/menu';
import { ConstantService } from './constant.service';
//import { ConstantService } from "../../services/constant.service";
//import {DataArray,ByteArray,BitArray} from "xdata/core"
@Injectable({
  providedIn: 'root'
})

export class EncrDecrService {
  

  constructor(
    //private byteArray:ByteArray
    ) { }

  keySize:any;
  iterationCount:any ;
 
  // //The set method is use for encrypt the value.
  // set(keys, value){
  //   var key = CryptoJS.enc.Utf8.parse(keys);
  //   var iv = CryptoJS.enc.Utf8.parse(keys);
  //   var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
  //   {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //   });

  //   return encrypted.toString();
  // }

  // //The get method is use for decrypt the value.
  // get(keys, value){
  //   var key = CryptoJS.enc.Utf8.parse(keys);
  //   var iv = CryptoJS.enc.Utf8.parse(keys);
  //   var decrypted = CryptoJS.AES.decrypt(value, key, {
  //       keySize: 128 / 8,
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7
  //   });

  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // }



  //  AesUtil () {
  //   this.keySize = 120 / 32;
  //   this.iterationCount = 1000;
  // };
  
  // generateKey (salt, passPhrase) {
  //   var key = CryptoJS.PBKDF2(
  //       passPhrase, 
  //       CryptoJS.enc.Hex.parse(salt),
  //       { keySize: this.keySize, iterations: this.iterationCount });
  //   return key;
  // }
  
  // encrypt (salt, iv, passPhrase, plainText) {
  //   var key = this.generateKey(salt, passPhrase);
  //   var encrypted = CryptoJS.AES.encrypt(
  //       plainText,
  //       key,
  //       { iv: CryptoJS.enc.Hex.parse(iv) });
  //   return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  // }
  
  // decrypt (salt, iv, passPhrase, cipherText) {
  //   var key = this.generateKey(salt, passPhrase);
  //   var cipherParams = CryptoJS.lib.CipherParams.create({
  //     ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  //   });
  //   var decrypted = CryptoJS.AES.decrypt(
  //       cipherParams,
  //       key,
  //       { iv: CryptoJS.enc.Hex.parse(iv) });
  //   return decrypted.toString(CryptoJS.enc.Utf8);
  // }
  
  // generateKeyAndIV(keyLength,ivLength,iterations,salt,password,md){
  //   const digestLength=16;
  
  //   const requiredLength=48;
 
  //   let generatedLength=0;
  //   let generatedData =new Array(requiredLength);
  //   md=md.reset();
  //   while(generatedLength < keyLength + ivLength){
  
              
  //             if (generatedLength > 0){
  //               md=md.update(generatedData .slice(generatedLength - digestLength, digestLength));
  //             }
  
  //             //this.byteArray.readMultiByte(password.length,password );
  //             md=md.update(this.toUTF8Array(password));
  //           if (salt != null){
  //               //salt=salt+"hims";
 
  //               md=md.update(this.toUTF8Array(salt.slice( 0, 8)));
  //           }

  //           md=md.finalize(generatedData.slice( generatedLength, digestLength));
              
  //           // additional rounds
  //           for (let i = 1; i < iterations; i++) {
  //             md=md.update(generatedData.slice( generatedLength, digestLength));
  //             md= md.finalize(generatedData, generatedLength, digestLength);
  //           }

  //           generatedLength = generatedLength+ digestLength;
  //           this.key=   generatedData.slice(0,keyLength).toString();
  //           this.generatedIv=generatedData.slice(keyLength,keyLength+ivLength);

  //       }
  //   }
  //   key:any;
  //   generatedIv:any;
  //   baseDecoded:any;
  //   pass="YblSonSheNeebal";
      
  //   decryptAES(transitmessage){
  //       this.pass ="YblSonSheNeebal";
  //       transitmessage=atob(transitmessage);
  
  //       //this.baseDecoded =  fromBase64(transitmessage);
  //       var salt = transitmessage.substring(8, 16);
  
  //       var hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.MD5, "MD5");
        
  //       this.generateKeyAndIV(32, 16, 1, salt, this.pass, hmac);
  //       var iv = transitmessage.substring(32, 32);
  
  //       CryptoJS.MD5.length;
    
  //       var encrypted = transitmessage.substring(16,32);
  
    
  //       // var key = CryptoJS.PBKDF2(this.pass, salt, {
  //       //     keySize: 32,
  //       //     iterations: 1
  //       //   });
      
  //       var decrypted = CryptoJS.AES.decrypt(encrypted, salt, { 
  //         iv: CryptoJS.lib.BlockCipherMode, 
  //         padding: CryptoJS.pad.Pkcs7,
  //         mode: CryptoJS.mode.CBC
          
  //       })
  
    
  //       return decrypted;
  //     }
  //     toUTF8Array(str) {
  //       var utf8 = [];
  //       for (var i=0; i < str.length; i++) {
  //           var charcode = str.charCodeAt(i);
  //           if (charcode < 0x80) utf8.push(charcode);
  //           else if (charcode < 0x800) {
  //               utf8.push(0xc0 | (charcode >> 6), 
  //                         0x80 | (charcode & 0x3f));
  //           }
  //           else if (charcode < 0xd800 || charcode >= 0xe000) {
  //               utf8.push(0xe0 | (charcode >> 12), 
  //                         0x80 | ((charcode>>6) & 0x3f), 
  //                         0x80 | (charcode & 0x3f));
  //           }
  //           // surrogate pair
  //           else {
  //               i++;
  //               // UTF-16 encodes 0x10000-0x10FFFF by
  //               // subtracting 0x10000 and splitting the
  //               // 20 bits of 0x0-0xFFFFF into two halves
  //               charcode = 0x10000 + (((charcode & 0x3ff)<<10)
  //                         | (str.charCodeAt(i) & 0x3ff));
  //               utf8.push(0xf0 | (charcode >>18), 
  //                         0x80 | ((charcode>>12) & 0x3f), 
  //                         0x80 | ((charcode>>6) & 0x3f), 
  //                         0x80 | (charcode & 0x3f));
  //           }
  //       }
  //       return utf8;
  //   }
    
    encryptData(data, secret) {

      try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), secret).toString();
      } catch (e) {
        
      }
    }
    
    decryptData(data, secret) {
    
      try {
        const bytes = CryptoJS.AES.decrypt(data, secret);
        if (bytes.toString()) {
          return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        return data;
      } catch (e) {
        
      }
    }
    
    encryptNew(plainText,secret){
      // encryptedBase64Key = 'bXVzdGJlMTZieXRlc2tleQ==';
      const parsedBase64Key = CryptoJS.enc.Base64.parse(secret);
      //encryptedData = null;
  
      // Encryption process
      //var plaintText = "Please encrypt this message!";
      
      // this is Base64-encoded encrypted data
      const encryptedData = CryptoJS.AES.encrypt(plainText, parsedBase64Key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
      });
     
      return encryptedData;
    }


    decryptNew(encryptedCipherText,secret){
      const parsedBase64Key = CryptoJS.enc.Base64.parse(secret);

      // Decryption process
    //var encryptedCipherText = 'U2WvSc8oTur1KkrB6VGNDmA3XxJb9cC+T9RnqT4kD90=' ; // or encryptedData;
    var decryptedData = CryptoJS.AES.decrypt( encryptedCipherText, parsedBase64Key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
    } );
    
    // this is the decrypted data as a string
    var decryptedText = decryptedData.toString( CryptoJS.enc.Utf8 );
    
    return decryptedText;
    }

    // AES GCM Decryption
      async decryptAESGCM(encryptedText): Promise<string>{
        try{
          const key = await this.importKey(ConstantService.encoded16ByteSecret);
          const rawEncrypted = Uint8Array.from(window.atob(encryptedText), c=>c.charCodeAt(0));
          const iv = rawEncrypted.slice(0,12);
          const encryptedArrayBuffer = rawEncrypted.slice(12);
          const decryptedArrayBuffer = await crypto.subtle.decrypt(
            {
              name: 'AES-GCM',
              iv: iv
            },
            key,
            encryptedArrayBuffer
          );
          return new TextDecoder().decode(new Uint8Array(decryptedArrayBuffer));
        }
        catch(error) {
          console.error('AES GCM Decryption failed', error);
          throw new Error('AES GCM Decryption Failed: '+error.message);
        }
      }
  
      private async importKey(keyBase64): Promise<CryptoKey> {
        const keyArrayBuffer = this.base64ToArrayBuffer(keyBase64);
        return await crypto.subtle.importKey(
          'raw',
          keyArrayBuffer,
          'AES-GCM',
          true,
          ['decrypt']
        );
      }
  
      private base64ToArrayBuffer(base64): ArrayBuffer {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for(let i = 0;i<len;i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
      }

}